import React, { useState } from "react";
import TemplatePreview from "../templatePreview/TemplatePreview";

const SmsEditor = ({ template, onSave }) => {
  const [text, setText] = useState(template.text);

  const handleSave = () => {
    onSave({ ...template, text });
  };

  return (
    <div>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows="6"
        className="w-full p-3 border rounded-lg dark:bg-gray-800 dark:text-white"
      />

      <button
        onClick={handleSave}
        className="mt-4 px-4 py-2 rounded-lg bg-blue-600 text-white"
      >
        Save
      </button>

      <h2 className="text-lg font-semibold mt-6">Preview</h2>
      <TemplatePreview html={text} isSms />
    </div>
  );
};

export default SmsEditor;
